const Flickity = require('flickity');
import 'flickity/css/flickity.css'
// import 'flickity-fullscreen/fullscreen.css'

const elem = document.querySelector('.inicio_soluciones .movil .main-carousel')
if(elem){
        const flkty = new Flickity( elem, {
        cellAlign: 'left',
        contain: true,
        fullscreen: false,
        lazyLoad: 0,
        wrapAround: true,
        autoPlay: 4500,
        pauseAutoPlayOnHover: false,
        dragThreshold: 10,
        selectedAttraction: 0.2,
        friction: 0.8
    });
}

const btnSoluciones = document.querySelectorAll('.inicio_soluciones .desktop .logos .logo')
const desktop = document.querySelector('.inicio_soluciones .desktop')

btnSoluciones.forEach((btn, index) => {
    btn.addEventListener('click', ()=>{
        desktop.setAttribute('id', `page${index+1}`)
    })
    
});


